export const YellowMinus = (props) => {
  return (
    <svg fill="none" xmlns="http://www.w3.org/2000/svg"
      width={props?.w ?? "20"} 
      height={props?.h ?? "20"} 
      viewBox={props?.v ?? "8 4 20 20"}
    >
      <g id="Group 28048">
      <g id="Group 27844">
      <g id="Ellipse 59" opacity="0.5" filter="url(#filter0_d_923_895)">
      <ellipse cx="17.9575" cy="14.5" rx="7.95747" ry="8.5" fill="#ECAA1F"/>
      </g>
      <g id="Ellipse 60" filter="url(#filter1_d_923_895)">
      <ellipse cx="17.9592" cy="14.501" rx="6.08628" ry="6.50124" fill="#ECAA1F"/>
      </g>
      </g>
      <rect id="Rectangle 5770" x="14.6809" y="12.9998" width="6.55321" height="3" fill="black"/>
      </g>
      <defs>
      <filter id="filter0_d_923_895" x="0" y="0" width="59.9149" height="61" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
      <feFlood floodOpacity="0" result="BackgroundImageFix"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feOffset dx="12" dy="16"/>
      <feGaussianBlur stdDeviation="11"/>
      <feComposite in2="hardAlpha" operator="out"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0.0868924 0 0 0 0 0.0985833 0 0 0 0 0.379167 0 0 0 0.33 0"/>
      <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_923_895"/>
      <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_923_895" result="shape"/>
      </filter>
      <filter id="filter1_d_923_895" x="1.87292" y="1.99976" width="56.1726" height="57.0024" filterUnits="userSpaceOnUse" colorInterpolationFilters="sRGB">
      <feFlood floodOpacity="0" result="BackgroundImageFix"/>
      <feColorMatrix in="SourceAlpha" type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0" result="hardAlpha"/>
      <feOffset dx="12" dy="16"/>
      <feGaussianBlur stdDeviation="11"/>
      <feComposite in2="hardAlpha" operator="out"/>
      <feColorMatrix type="matrix" values="0 0 0 0 0.0868924 0 0 0 0 0.0985833 0 0 0 0 0.379167 0 0 0 0.33 0"/>
      <feBlend mode="normal" in2="BackgroundImageFix" result="effect1_dropShadow_923_895"/>
      <feBlend mode="normal" in="SourceGraphic" in2="effect1_dropShadow_923_895" result="shape"/>
      </filter>
      </defs>
    </svg>
  )
}